export interface Country {
  value: string;
  viewValue: string;
}
export interface State {
  value: string;
  viewValue: string;
}
